module.exports = __webpack_public_path__ + "media/images/icon-views-22349b6cb3513831d48022f3313e12f2.svg";